export default __webpack_public_path__ + "86e836d838d06e9aa1e1a3fcf352327f.png";